// extracted by mini-css-extract-plugin
module.exports = {"mhA":"mhA_mhA__MwGUR"};